import { render, staticRenderFns } from "./ErpConnectSetting.vue?vue&type=template&id=e0b4ba84&scoped=true"
import script from "./ErpConnectSetting.vue?vue&type=script&lang=js"
export * from "./ErpConnectSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b4ba84",
  null
  
)

export default component.exports